module.exports = __webpack_public_path__ + "img/20250114_supplementplus_01.5dcfdf36.jpg";